export default __webpack_public_path__ + "static/media/279.0a255a65.png";